/* eslint-disable no-nested-ternary */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  online: 'waiting',
  ping: null,
};

const slice = createSlice({
  name: 'ws-connection',
  initialState,
  reducers: {
    setOnline(state, { payload }) {
      if (payload?.ms < 100) {
        state.online = 'successful';
      } else if (payload?.ms < 1000) {
        state.online = 'waiting';
      } else {
        state.online = 'failed';
      }
    //   console.log('ping :', payload?.ms);
      state.ping = payload?.ms || null;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setOnline } = slice.actions;
